import { getToken } from "./apiHelper";
import api from "./api";

export const checkListService = {
  getAllCheckLists: async (page,pageSize,filter)  => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/Vouchers/GetAllPaginatedByCurrentId?page=${page}&pageSize=${pageSize}&search=${filter}&orderByProperty=Date&asc=false`,  axiosConfig);

      return response.data.data;
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    } 
  }, getCheckLists: async (page,pageSize)  => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/Vouchers/getallpaginated?page=${page}&pageSize=${pageSize}&orderByProperty=Date&asc=false`,  axiosConfig);

      return response.data.data;
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    } 
  },
  createCheckList: async (data) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.post(
        `/Vouchers`,
        data,
        axiosConfig
      );

      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },
  updateCheckList: async (data) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      const response = await api.put(`/Vouchers`, data, axiosConfig);

      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },

  deleteCheckList: async (id) => {

    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
        data:{"id":id}
      };
      const response = await api.delete(`/Vouchers`, axiosConfig);
      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }
  },
     
};